import React from "react";
import { ToggleSwitchProps } from "../../types/screensTypes";
import styles from "./ToggleSwitch.module.css";

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, className }) => {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };
    return (
        <label className={[styles.switch, className].filter(Boolean).join(" ")} onClick={handleClick}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
            />
            <span className={`${styles.slider} ${styles.round}`} />
        </label>
    );
};

export default ToggleSwitch;
